import { Link } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";

export function AdminHeader({ tab, setTab, chartsCount, onLogout }) {
  const tabs = [
    ["upload", "Upload"],
    ["results", "Results"],
    ["text", "Image → Text"],
    ["charts", `Charts (${chartsCount})`],
    ["categories", "Categories"],
    ["telegram", "Telegram"],
  ];

  return (
    <div className="border-b border-white/10 bg-black/60">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <p className="font-heading text-lg font-black uppercase tracking-tight">
          Rocky <span className="text-[#FFD700]">Agency</span>
          <span className="ml-3 font-mono text-[10px] font-normal uppercase tracking-[0.25em] text-[#666666]">Admin</span>
        </p>
        <div className="flex items-center gap-3">
          <Link
            to="/"
            data-testid="admin-view-site"
            className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs text-[#A1A1A6] transition-colors duration-300 hover:text-white"
          >
            <ExternalLink className="h-3 w-3" /> View site
          </Link>
          <button
            onClick={onLogout}
            data-testid="admin-logout-btn"
            className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs text-[#A1A1A6] transition-colors duration-300 hover:border-[#E63946]/60 hover:text-[#E63946]"
          >
            <LogOut className="h-3 w-3" /> Logout
          </button>
        </div>
      </div>
      <div className="mx-auto flex max-w-6xl flex-wrap gap-2 px-6 pb-4">
        {tabs.map(([key, label]) => (
          <button
            key={key}
            data-testid={`admin-tab-${key}`}
            onClick={() => setTab(key)}
            className={`rounded-full px-5 py-2 text-xs font-bold uppercase tracking-[0.12em] transition-colors duration-300 ${
              tab === key ? "bg-[#FFD700] text-black" : "border border-white/15 text-[#A1A1A6] hover:text-white"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

export function ReminderBanner({ reminders, onEnter }) {
  if (reminders.length === 0) return null;
  return (
    <div data-testid="draw-reminder-banner" className="border-b border-[#FFD700]/30 bg-[#FFD700]/10">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-3 px-6 py-3">
        <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-[#FFD700]" />
        <p className="text-xs font-semibold text-[#FFD700]">
          Result pending: {reminders.map((r) => `${r.label} (${r.overdue_min}m)`).join(" · ")}
        </p>
        <button
          data-testid="reminder-goto-results"
          onClick={onEnter}
          className="rounded-full bg-[#FFD700] px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-black"
        >
          Enter now
        </button>
      </div>
    </div>
  );
}
